module.exports = __webpack_public_path__ + "static/media/skifly.dc6d85e1.jpg";